export var SubscriptionStatus;
(function (SubscriptionStatus) {
    SubscriptionStatus["Active"] = "Active";
    SubscriptionStatus["Cancelled"] = "Cancelled";
    SubscriptionStatus["GracePeriod"] = "Grace Period";
    SubscriptionStatus["OnHold"] = "On Hold";
    SubscriptionStatus["Paused"] = "Paused";
    SubscriptionStatus["Expired"] = "Expired";
    SubscriptionStatus["Refunded"] = "Refunded";
})(SubscriptionStatus || (SubscriptionStatus = {}));
export const BLOCKING_SUBSCRIPTION_STATUSES = [
    SubscriptionStatus.Active,
    SubscriptionStatus.GracePeriod,
];
export const BUSINESS_DELETE_BLOCKED_REASON = 'active_subscription';
//# sourceMappingURL=subscription-status.const.js.map